import { Box } from '@mui/material'
import React from 'react'
import { useFormikContext } from 'formik'
import { IdlePeriodSettingsFormModel } from 'src/Libs/smart-charge/models'
import EmsIdlePeriodListItem from 'src/Libs/smart-charge/components/ems-idle-period/EmsIdlePeriodListItem'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { AccordionItem } from '@e3dc-react/shell/Elements/Accordion'
import { BlankViewImageVariants, BlankView, BlankViewImageSizes } from 'src/Components/blank-view'

interface Props {
  name: string
  onRemove: (index: number) => void
  hasWritingRights?: boolean
  hide?: boolean
}

const EmsIdlePeriodFormList: React.FC<Props> = ({ name, onRemove, hasWritingRights = true, hide = false }) => {
  const { t } = useCustomTranslation()
  const { values } = useFormikContext<IdlePeriodSettingsFormModel>()

  if (values.emsIdlePeriod.length === 0) {
    return (
      <Box>
        <BlankView
          imageVariant={BlankViewImageVariants.Neutral}
          imageSize={BlankViewImageSizes.Small}
          title={'systemSettings.smartFunctions.emsIdlePeriods.no-blocking-time-added'}
          explanation={'systemSettings.smartFunctions.emsIdlePeriods.no-blocking-time-added-explanation'}
        />
      </Box>
    )
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        overflow: 'hidden',
        height: hide ? 0 : 'auto',
        opacity: hide ? 0 : 1,
        transition: 'height 0.3s ease, opacity 0.3s ease',
      }}
    >
      {values.emsIdlePeriod.map((item, index) => {
        const handleRemove = (): void => {
          onRemove(index)
        }
        const fieldName = `${name}.${index}`
        const typeString = t(`smartCharge.periodType.${item.type}`)
        const description = item.description
        const title = description || `${typeString} ${item.startTimeOfDay} - ${item.endTimeOfDay}`.trim()

        return (
          <AccordionItem key={fieldName} title={title} depth={1} expanded elevation={0} disabled={!hasWritingRights}>
            <EmsIdlePeriodListItem name={fieldName} key={fieldName} onRemove={handleRemove} hasWritingRights={hasWritingRights} />
          </AccordionItem>
        )
      })}
    </Box>
  )
}

export default EmsIdlePeriodFormList
